export default __webpack_public_path__ + "static/media/manastır.74632c48.mp4";